
<v-container class="productContainer">
  <div class="detailLayout">
    <div class="shopNavigationButtons detailNavigation">
      <v-btn class="backButton" @click="$router.go(-1)">
        <v-icon class="buttonIcon">arrow_back</v-icon>
        {{ $t("BUTTON_BACK_TO_PRODUCTS") }}
      </v-btn>
    </div>
    <StickyDiscountBanner v-if="hasCoupons" class="detailDiscount" full-width :suppress-floating="configuring"
                          :get-boundary="getBoundary" :auto-open-on-mobile="false"/>
    <div class="detailImage">
      <v-img :src="product.imageUrl" class="productImage" contain></v-img>
    </div>
    <div class="detailContent">
      <v-row v-show="error">
        <v-col cols="12">
          <v-alert type="error" v-show="error" transition="fade-transition" class="addedToBasketAlert">{{
              error
            }}
          </v-alert>
        </v-col>
      </v-row>
      <div class="productDetails elevation-3">
        <div class="productInfo">
          <ProductDiscountBadge :price="price" :instead-of="product.setPriceInsteadOf"/>
          <header class="productHeader">
            <h1 class="display-1">{{ product.name }}</h1>
          </header>
          <div class="detailBody">
            <div class="description" v-html="product.longDescription"></div>
            <ProductActions class="detailActions" :price="price" :instead-of="product.setPriceInsteadOf"
                            :from="product.detailedConfigurationSurcharge > 0"
                            :label="$t('BUTTON_ADD_PRODUCT')" icon="add" @configure="startConfiguration"/>
          </div>
        </div>
        <ProductConfigurationDialog ref="configurationDialog" v-model="configuring" :product="product"
                                    @addedToBasket="onAddedToBasket" @error="onConfigurationError"/>
      </div>
    </div>
  </div>
</v-container>
